import { useHtmlTheme } from './hooks';

export const HtmlThemeProvider = ({ children }: any) => {
  useHtmlTheme();

  return <>{children}</>;
};
